import { render, staticRenderFns } from "./PremiumDashboard.vue?vue&type=template&id=3b2a13f7&scoped=true"
import script from "./PremiumDashboard.vue?vue&type=script&lang=js"
export * from "./PremiumDashboard.vue?vue&type=script&lang=js"
import style0 from "./PremiumDashboard.vue?vue&type=style&index=0&id=3b2a13f7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b2a13f7",
  null
  
)

export default component.exports